import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../pages/Dashboard.vue";
import SignUp from "../pages/SignUp.vue";
import Login from "../pages/Login.vue";
import Devices from "../pages/Devices.vue";

import Playlists from "../pages/Playlists.vue";
import About from "../pages/About.vue";
import Media from "../pages/Media.vue";
import Settings from "../pages/Settings.vue";
import Help from "../pages/Help.vue";

import FBAuth from "../pages/auth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "dashboard",
    alias: "/dashboard",
    component: Dashboard,
  },

  {
    path: "/auth",
    name: "auth",
    component: FBAuth,
  },
  {
    path: "/sign-up",
    name: "sign-up",
    component: SignUp,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/devices",
    name: "devices",
    component: Devices,
  },

  {
    path: "/settings",
    name: "settings",
    component: Settings,
  },
  {
    path: "/about",
    name: "about",
    component: About,
  },
  {
    path: "/playlist",
    name: "playlist",
    component: Playlists,
  },
  {
    path: "/media",
    name: "media",
    component: Media,
  },

  {
    path: "/help",
    name: "help",
    component: Help,
  },
  {
    path: "/fu",
    name: "FileUpload",
    component: () => import(/* webpackChunkName: "about" */ "../components-v2/Media/FileUpload.vue"),
  },

  // Always leave this as last one
  {
    path: "*",
    component: () => import("../pages/Error404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
